export enum ITipoUsuario {
    USUARIO_VELES_DEMAIS = 1,
    USUARIO_VELES_COMERCIAL = 2,
    USUARIO_VELES_EXPERIENCIA_DO_CLIENTE = 3,
    VELES_SUPERVISOR_COMERCIAL = 4,
    USUARIO_CLIENTE = 5
}

export const tipoUsuarioOptions: ITipoUsuario[] = [1, 2, 3, 4]

export const tipoUsuarioToLabel = (tipoUsuario: ITipoUsuario): string => {
    switch (tipoUsuario) {
        case 1:
            return 'Demais'
        case 2:
            return 'Comercial'
        case 3:
            return 'Experiência do Cliente'
        case 4:
            return 'Supervisor Comercial'
        case 5:
            return 'Cliente'
        default:
            return 'Cliente'
    }

}